import { useFindSuggestedCatalogs } from '../../../services/modules/catalogs/catalogs.queries';
import { useAppEnvironmentStore } from '../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInBrandEnvironment } from '../../../stores/AppEnvironment/appEnvironment.store.selectors';
import { useAbility } from '../../users/AbilityContext';
import { SUGGESTED_CATALOGS_LIMIT } from '../globalSearch.constants';
import { SuggestedCatalog } from '../globalSearch.types';

interface UseSuggestedCatalogsParams {
  isEnabled: boolean;
}

const useSuggestedCatalogs = ({ isEnabled }: UseSuggestedCatalogsParams) => {
  const ability = useAbility();
  const isBrandEnvironment = useAppEnvironmentStore(selectIsInBrandEnvironment);
  const hasCatalogsAccess = ability.can('read', 'catalogs') && ability.can('menu', 'catalogs');

  const { data } = useFindSuggestedCatalogs(SUGGESTED_CATALOGS_LIMIT, {
    enabled: isEnabled && isBrandEnvironment && hasCatalogsAccess,
  });

  const catalogs: SuggestedCatalog[] = (data?.data ?? []).map(({ id, name, imageUrl }) => ({
    id,
    name,
    imageUrl: imageUrl ?? undefined,
  }));

  return { catalogs };
};

export default useSuggestedCatalogs;
